import * as React from "react";
import { Fieldset } from "@bizform/primereact/components/fieldset/Fieldset";
import {
    ComponentCategory,
    ComponentElementManifest,
    ComponentElementProperty
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import { Static } from "@bizform/type/decorator/Static.decorator";
import { ComponentElement, ComponentElementStatic } from "@bizform/type/model/component_element/ComponentElement.model";
import { DomAttribute } from "@bizform/type/model/dom/DomAttribute.model";
import { PluginType } from "@bizform/type/model/model/Plugin.model";
import { WindowKey } from "@bizform/type/model/model/WindowKey.model";
import { Debug } from "@bizform/helper/dist/js/bizflow/helper.min";
import { ComponentElementClass, ReactComponentElementInit } from "@bizform/core/dist/js/bizflow/core.min";
import { I18n } from "../misc/model/I18n.model";


type Props =  {
};

type State =  {
    show: boolean;
    projectId: string;
    formId: string;
};

/**
 * Embed Form component element
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @class
 */
@ComponentElementClass()
@Static<ComponentElementStatic<string>>()
export class BfEmbedPagePanel extends React.Component<Props, State> implements ComponentElement<null> {
    static readonly pluginType: string = PluginType.EMBEDPAGEHANDLER;

    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_Fo2a42dULlKDaxKhKvosrEns7iKdzeo",
        category: ComponentCategory.HANDLER,
        label: I18n.handler.embedPagePanel.label,
        description: I18n.handler.embedPagePanel.description,
        icon: "",
        property: null
    };

    destroyed: boolean;
    accessibility: boolean;
    elementId: string;
    applicationId: string;
    formId: string;
    parentDom: HTMLElement;

    /** action */
    onDisabled() {
        this._show();
    }
    onReadOnly() {
        this._show();
    }
    onPrint() {
        this._show();
    }
    onEdit() {
        this._show();
    }

    focus() {}
    setProperty(property: ComponentElementProperty) {
        try {
            this.setState({
                show: this.state.show,
                projectId: property.attribute.projectId.value,
                formId: property.attribute.formId.value
            });
        } catch (e) {
            Debug.console.error("setProperty", e);
        }
    }

    noDisplayInheritance() {
    }

    @ReactComponentElementInit(BfEmbedPagePanel)
    static init(): ComponentElement<string> {
        return;
    }

    initDone(): void {
    }

    destroy(): void {
        this.destroyDone();
    }

    destroyDone(): void {
    }

    /* for React */
    props: Props;
    state: State;

    static defaultProps = {
    };

    constructor(props?: Props) {
        super(props);
        this.state = {
            show: false,
            projectId: "",
            formId: ""
        };
    }

    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): boolean {
        return this.state.show !== nextState.show || this.state.projectId !== nextState.projectId || this.state.formId !== nextState.formId;
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        Debug.console.error(error, errorInfo);
    }

    render(): React.ReactNode {
        if (!this.state.show) {
            return null;
        } else {
            if (window[WindowKey.DESIGNMODE]) {
                return (
                    <Fieldset
                        id={this.elementId}
                        legend=""
                        toggleable={true}>
                        {this._container()}
                    </Fieldset>
                );
            } else {
                return (
                    <React.Fragment>
                        {this._container()}
                    </React.Fragment>
                );
            }
        }
    }

    private _show() {
        this.setState({
            show: true,
            projectId: this.state.projectId,
            formId: this.state.formId
        });
    }

    private _container() {
        const attr = {
            [DomAttribute.APPLICATIONID]: this.state.projectId,
            [DomAttribute.FORMID]: this.state.formId,
            [DomAttribute.EMBEDPAGE]: ""
        };
        return (
            <div {...attr}>
            </div>
        );
    }
}
